import { render, staticRenderFns } from "./StructureWorkOrder.vue?vue&type=template&id=cf0fb84c"
import script from "./StructureWorkOrder.vue?vue&type=script&lang=js"
export * from "./StructureWorkOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports